import styled from "styled-components";

const Header = styled.div.attrs({
  className:
    "bg-[#343030] h-24 flex md:flex-col justify-center items-center md:items-start sticky top-0 z-10",
})``;

const Back = styled.div.attrs({
  className: "bg-[#606060] h-full p-10 ",
})``;

const Card = styled.div.attrs({
  className:
    "bg-[#FFFFFF] max-w-4xl mx-5 lg:mx-auto my-5 p-2 sm:p-16 md:p-24 rounded-lg shadow-xl",
})``;

const Tittle = styled.h1.attrs({
  className: "text-2xl text-red-500 font-bold",
})``;

const SubTittle = styled.h2.attrs({
  className: "text-xl text-red-500 mt-12",
})``;

const SubtitleBox = styled.div.attrs({
  className: "flex gap-2 mt-3",
})``;

const FormContainer = styled.div.attrs({
  className: "w-full flex flex-col gap-4 mt-6 mb-5",
})``;

export default {
  Header,
  Back,
  Card,
  Tittle,
  SubTittle,
  SubtitleBox,
  FormContainer,
};
